import { slideDown, slideUp } from '@js/common/customFunctions.js';

const DeviceMenu = () => {
    const mbnav = document.querySelector('.mbnav');
    const hamBurger = document.querySelector('.hamburger');
    const hamBurgerClose = document.querySelector('.hamburger-close'); // ✅ New close button
    const overlay = document.querySelectorAll('.mbnav__backdrop, .mbnav__close');
    const body = document.body;

    if (mbnav) {
        // ✅ Menu Close Function
        function menuClose() {
            hamBurger.classList.remove('is-clicked');
            body.classList.remove('scroll-fixed');
            mbnav.classList.remove('is-open');

            // Reset sub-menus
            mbnav.querySelectorAll('.menu-wrap li').forEach(li => li.classList.remove('is-open'));
            const menuWrap = mbnav.querySelector('.mbnav__inner > .menu-wrap');
            if (menuWrap) {
                menuWrap.style.setProperty('--leftSlide', '0');
            }

            // Close all submenus
            mbnav.querySelectorAll('.mbnav__inner .sub-menu').forEach(subMenu => {
                slideUp(subMenu);
            });
        }

        // ✅ Overlay click to close
        overlay.forEach(el => {
            el.addEventListener('click', menuClose);
        });

        // ✅ Hamburger Close button click
        if (hamBurgerClose) {
            hamBurgerClose.addEventListener('click', menuClose);
        }

        // ✅ Hamburger toggle
        if (hamBurger) {
            hamBurger.addEventListener('click', () => {
                if (hamBurger.classList.contains('is-clicked')) {
                    menuClose();
                } else {
                    hamBurger.classList.add('is-clicked');
                    mbnav.classList.add('is-open');
                    body.classList.add('scroll-fixed');
                }
            });
        }

        // ✅ Mark has-sub
        const mbnavState = document.querySelector('.mbnav__state');
        const clickable = mbnavState ? mbnavState.getAttribute('data-clickable') === 'true' : false;
        const menuItems = document.querySelectorAll('.mbnav ul.menu > li');

        menuItems.forEach(li => {
            if (li.querySelector('ul')) {
                li.classList.add('has-sub');
                const ul = li.querySelector('ul');
                ul.classList.add('sub-menu');
                const link = li.querySelector('a');
                if (link) {
                    const caret = document.createElement('em');
                    caret.className = 'mbnav__caret';
                    link.insertAdjacentElement('afterend', caret);
                }
            }
        });

        // ✅ Handle caret triggers
        const carets = document.querySelectorAll('.mbnav .has-sub > .mbnav__caret');
        carets.forEach(caret => {
            if (clickable) {
                caret.classList.add('trigger-caret');
            } else {
                const link = caret.previousElementSibling;
                if (link && link.tagName === 'A') {
                    link.classList.add('trigger-caret');
                    link.setAttribute('href', 'javascript:;');
                }
            }
        });

        // ✅ Wrap elements
        const inner = document.querySelector('.mbnav__inner');
        if (inner && !inner.querySelector('.menu-wrap')) {
            const wrapper = document.createElement('div');
            wrapper.className = 'menu-wrap';
            const innerWrap = document.createElement('div');
            innerWrap.className = 'menu-inner';

            while (inner.firstChild) {
                innerWrap.appendChild(inner.firstChild);
            }

            wrapper.appendChild(innerWrap);
            inner.appendChild(wrapper);
        }

        // ✅ Open sub-menu toggle
        document.querySelectorAll('.mbnav .has-sub > .trigger-caret').forEach(trigger => {
            trigger.addEventListener('click', () => {
                const li = trigger.closest('li');
                const siblings = li.parentElement.children;
                Array.from(siblings).forEach(sib => {
                    if (sib !== li) {
                        sib.classList.remove('is-open');
                    }
                });
                li.classList.toggle('is-open');
                body.classList.add('scroll-fixed');
            });
        });

        // ✅ Forward slide for nested menus
        document.querySelectorAll('.mbnav__inner .mbnav__caret').forEach(caret => {
            caret.addEventListener('click', function() {
                const subMenu = caret.parentNode.querySelector('ul.sub-menu');

                // Toggle this sub-menu
                if (subMenu && (subMenu.style.display === 'none' || !subMenu.style.display)) {
                    slideDown(subMenu);
                } else {
                    slideUp(subMenu);
                }

                // Close sibling sub-menus
                Array.from(caret.parentNode.parentNode.children).forEach(sibling => {
                    const siblingSubMenu = sibling.querySelector('ul.sub-menu');
                    if (sibling !== caret.parentNode && siblingSubMenu) {
                        slideUp(siblingSubMenu);
                    }
                });
            });
        });

        // ✅ Adjust padding from header height
        function setMenuPaddingFromHeader() {
            const menuInners = document.querySelectorAll('.mbnav .menu-wrap .menu-inner');

            const updatePadding = () => {
                const header = document.querySelector('header.main-header');
                if (!header) {return;}
                const headerHeight = header.offsetHeight;
                menuInners.forEach(inner => {
                    inner.style.paddingTop = `${headerHeight}px`;
                });
            };

            updatePadding();
            window.addEventListener('resize', updatePadding);
        }

        setMenuPaddingFromHeader();
    }
};

export default DeviceMenu;
